import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const CameraVideoIcon = React.memo(
  ({
    fill = variables['colors-mc-white'],
    fillCircle = variables['colors-mc-primary'],
    width = 35,
    viewBox = '0 0 35 35'
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect
        id='Rectangle_1420'
        data-name='Rectangle 1420'
        width='35'
        height='35'
        rx='17.5'
        fill={fillCircle}
      />
      <g id='Group_4399' data-name='Group 4399' transform='translate(9 12)'>
        <rect
          id='Rectangle_1413'
          data-name='Rectangle 1413'
          width='11'
          height='10.8'
          rx='2'
          fill={fill}
        />
        <path
          id='Path_12340'
          data-name='Path 12340'
          d='M22,8.283v6.233a.941.941,0,0,1-1,.869,1.081,1.081,0,0,1-.707-.255l-3.586-3.117a.791.791,0,0,1,0-1.229l3.586-3.117a1.109,1.109,0,0,1,1.414,0A.816.816,0,0,1,22,8.283Z'
          transform='translate(-4 -6)'
          fill={fill}
          fillRule='evenodd'
        />
      </g>
    </svg>
  )
);
CameraVideoIcon.displayName = 'CameraVideoIcon';

export default CameraVideoIcon;
